<script lang="ts" setup>
import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <VueQueryDevtools />
  </div>
</template>
